<template>
	<div class="recurrence-list-placeholder">
		<h1 class="title">{{ title || translate( `title` ) }}</h1>
		<TeamingButton2
			@click="$emit( `create` )"
		>
			{{ buttonText || translate( `createRecurrenceButton` ) }}
		</TeamingButton2>
	</div>
</template>

<script>
import {
	TranslateMixin,
	TeamingButton2
} from "@teaming/common-ui";

export default {
	name: "RecurrenceListPlaceholder",
	teamingPackage: "common-team",
	mixins: [ TranslateMixin, ],
	emits: [ "create", ],
	components: {
		TeamingButton2,
	},
	props: {
		title: {
			type: String,
			required: false,
		},
		buttonText: {
			type: String,
			required: false,
		},
	},
};
</script>

<style lang="scss" scoped>
$titleColor: $color1-700;
$backgroundColor: $color1-050;

.recurrence-list-placeholder {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 1rem;

	background-color: $backgroundColor;
	border-radius: 1rem;
}

.recurrence-list-placeholder .title {
	@include font-and-line-for(1);
	font-weight: 600;
	color: $titleColor;
}
</style>
